import { variantProvider } from '@/app'
import { View } from '@/components'

type LessonPaginationIndicatorProps = {
  pages: number
  currentPage: number
}

export const LessonPaginationIndicator = ({ pages, currentPage }: LessonPaginationIndicatorProps) => {
  const steps = Array(pages).fill(0)

  return (
    <View variants={['row', 'center', 'gap:1', 'pointerEvents:none', 'fullWidth']}>
      {steps?.map((_, i) => {
        if (i == 0) return null
        const isOldStep = i <= currentPage

        return <View key={'learn-view-header-' + i} css={[styles.step, isOldStep && styles.stepFill]} />
      })}
    </View>
  )
}

const stepHeight = 4

const styles = variantProvider.createComponentStyle(
  theme => ({
    step: {
      flex: 1,
      height: stepHeight,
      borderRadius: theme.borderRadius.rounded,
      backgroundColor: theme.colors.neutral4,
    },
    stepFill: {
      backgroundColor: theme.colors.primary3,
    },
  }),
  true,
)
